import CtaDouble from './CtaDouble'
export default CtaDouble
